import { node } from "~/util/dom";

export const MarkerGEO = function MarkerGEO(coords) {
	const span = node("span", { className: "geolocation-mark" });
	const options = {
		url: span,
		anchor: {
			left: 10,
			top: 10,
		},
	};

	SMap.Marker.call(this, coords, null, options);
};

// eslint-disable-next-line prefer-object-spread
MarkerGEO.prototype = Object.create(Object.assign({}, SMap.Marker.prototype));
